import React, { useEffect, useRef, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import triangle from "../../images/triangle.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Select from "react-select";
import moment from "moment";
import Toastify from "../common/Toastify";
import DeleteItemModal from "../../modal/DeleteItemModal";
import { DELETEREQUEST, GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import { addTrailingZeros, formatPrice } from "../helpers/common";
import { generateProductCreditPdf } from "../Pdfs/ProductCredit";

const ViewEditProduceCredit = () => {
    const { id } = useParams();
    const { user } = useAuth();

    const navigate = useNavigate();
    const creditDetailObj = {
        Qty: '',
        UnitID: '',
        ProductID: '',
        AgentID: '',
        Comment: '',
        ProdCreditAmt: '',
        ProdCreditGSTAmt: '',
    }
    const [errors, setErrors] = useState({});
    const [creditDetails, setCreditDetails] = useState([creditDetailObj]);
    const [customerDetailsObj, setCustomerDetailsObj] = useState(null);
    const [agents, setAgents] = useState([]);
    const [units, setUnits] = useState([]);
    const [products, setProducts] = useState([]);
    const [returnDate, setReturnDate] = useState(moment().format('YYYY-MM-DD'));
    const [reference, setReference] = useState('0');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState();
    const [ShowDeleteCreditModal, setShowDeleteCreditModal] = useState(false);

    useEffect(() => {
        var headerHeight = $("header").outerHeight();
        var mainHeight = $(window).height() - headerHeight;
        $("main").height(mainHeight);
        $("main").css("margin-top", headerHeight + "px");

        var tableRow = ".table-form thead > tr";

        $(tableRow).on("focusin", function () {
            $(this).addClass("focus-tr");
        });

        $(tableRow).on("focusout", function () {
            $(this).removeClass("focus-tr");
        });
    });

    useEffect(() => {
        const fetchData = async () => {
            if (id) {
                let URL = process.env.REACT_APP_API_URL + `/get-produce-credit/${id} `;
                let response = await GETREQUEST(URL, user.jwtToken);
                if (response?.data) {
                    const {credit, units, agents, products} = response.data;

                    setCustomerDetailsObj(credit?.tblCustomer);
                    setReference(credit?.CNReference);
                    setReturnDate(moment(credit?.CNDate).format('YYYY-MM-DD'));
                    setCreditDetails(prevProdDetails => {
                        const updatedProdDetails = [...credit.tblProdCreditDetails, creditDetailObj];
                        return updatedProdDetails;
                    });

                    let productList = [];
                    products?.forEach((item) => {
                        if (item.product.Current)
                            productList = [...productList, { label: item.product?.ProductName, value: item.value, productCode: item.label, GST: item.product?.GST }];
                    });
                    setProducts(productList);

                    let unitList = [];
                    units?.forEach((item) => {
                        unitList = [...unitList, { label: item.UnitName, value: item.UnitID }];
                    });
                    setUnits(unitList);

                    let agentList = [];
                    agents.forEach((item) => {
                        agentList = [...agentList, { label: item.AgentCode, value: item.AgentID }];
                    });
                    setAgents(agentList);
                }
            }
        }
        fetchData();
    }, [id]);

    const CustomOption = (props) => {
        return (
            <div
                className=""
                style={{
                    background: props.isFocused
                        ? '#01B1E3'
                        : props.isSelected
                            ? 'rgb(54, 179, 126)'
                            : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
                }}
                {...props.innerProps}
                ref={props.innerRef}
            >
                {props.label}
            </div>
        )
    }

    const calculateGST = (value, index) => {
        value = parseFloat(value)
        let productID = creditDetails[index].ProductID;
        let GST = products.find(prod => prod.value === productID)?.GST;
        if (GST) {
            let GSTValue = value / 11;
            setCreditDetails(prevProdDetails => {
                const updatedProdDetails = [...prevProdDetails];
                updatedProdDetails[index].ProdCreditGSTAmt = GSTValue
                return updatedProdDetails;
            });
        }
    }

    const calculateTotalCredit = () => {
        let total = 0;
        creditDetails.map((credit) => {
            let value = credit.ProdCreditAmt;
            if (value)
                total += parseFloat(value);
        });
        return total ? total.toFixed(2) : 0.00
    }

    const addNewRow = (e, index) => {
        if (Object.keys(errors).length > 0) {
            e.preventDefault();
        }
        else if (creditDetails.length - 1 == index) {
            setCreditDetails(prevProdDetails => {
                const updatedProdDetails = [...prevProdDetails, creditDetailObj];
                return updatedProdDetails;
            });
        }
    }

    const handleRowDelete = (index) => {
        let creditD = creditDetails.filter((a, i) => index !== i);
        setCreditDetails(creditD);
    };

    const handlePreview = () => {
        let updatedProdDetails = [];
        creditDetails.map((creditItem) => {
            if (creditItem.Qty !== '' && creditItem.UnitID !== '' && creditItem.ProductID && creditItem.ProdCreditAmt) {
                updatedProdDetails.push({
                    ...creditItem,
                    ProdCreditAmt: creditItem.ProdCreditAmt ? parseFloat(creditItem.ProdCreditAmt).toFixed(2) : 0,
                    ProdCreditGSTAmt: creditItem.ProdCreditGSTAmt ? parseFloat(creditItem.ProdCreditGSTAmt).toFixed(2) : 0,
                })
            }
        })
        let previewData = {
            CNID: id,
            ReturnDate: returnDate,
            ReferenceNo: reference,
            tblCustomer: customerDetailsObj,
            products,
            units,
            creditDetails: updatedProdDetails
        }
        generateProductCreditPdf(previewData);
    }

    const handleUpdate = async () => {
        let updatedProdDetails = [];
        creditDetails.map((creditItem) => {
            if (creditItem.Qty !== '' && creditItem.UnitID !== '' && creditItem.ProductID && creditItem.ProdCreditAmt) {
                updatedProdDetails.push({
                    ...creditItem,
                    ProdCreditAmt: creditItem.ProdCreditAmt ? parseFloat(creditItem.ProdCreditAmt).toFixed(2) : 0,
                    ProdCreditGSTAmt: creditItem.ProdCreditGSTAmt ? parseFloat(creditItem.ProdCreditGSTAmt).toFixed(2) : 0,
                })
            }
        })
        let payload = {
            CNID: id,
            CustomerID: customerDetailsObj?.CustomerID,
            ReturnDate: returnDate,
            ReferenceNo: reference,
            creditDetails: updatedProdDetails
        }
        let updateURL = process.env.REACT_APP_API_URL + "/update-produce-credit";
        setMessage('');
        setMessageType('');
        let response = await POSTREQUEST(updateURL, payload, user.jwtToken);
        if (response?.data) {
            if (response.data.success) {
                setMessage(response.data.message);
                setMessageType('success');
            } else {
                setMessage(response.data.message);
                setMessageType('error');
            }
        } else {
            setMessage(response?.error?.message || 'Failed to update product credit !!');
            setMessageType('error');
        }
    }

    const handleDelete = async () => {
        setShowDeleteCreditModal(false);
        let URL = `${process.env.REACT_APP_API_URL}/delete-produce-credit/${id}`;
        let response = await DELETEREQUEST(URL, user.jwtToken);
        if (response?.data) {
            setMessageType('')
            setMessage('')
            if (response.data.success) {
                setMessage(response.data.message);
                setMessageType('success');
                setTimeout(() => {
                    navigate("/all-produce-credits");
                }, 2000);
            } else {
                setMessage(response.data.message);
                setMessageType('error');
            }
        } else {
            setMessage(response?.error?.message || 'Failed to delete product !!');
            setMessageType('error');
        }
    }

    return (
        <React.Fragment>
            {ShowDeleteCreditModal && <DeleteItemModal modal={ShowDeleteCreditModal} handleDelete={handleDelete} setModal={setShowDeleteCreditModal} title={"Delete Produce Credit ?"} text={"Do you want to delete this Produce Credit ?"} />}
            <Header />
            {message && <Toastify message={message} type={messageType} />}
            <main className="bg-lite-grey overflow-auto">
                <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
                    <div className="table-elements">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item fs-15">
                                    <Link
                                        to="/all-produce-credits"
                                        className="text-decoration-none text-primary"
                                    >
                                        Produce Credits
                                    </Link>
                                </li>
                                <li
                                    className="breadcrumb-item fs-15 active"
                                    aria-current="page"
                                >
                                    View/Edit
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="card border-bottom-0">
                        <div className="card-header bg-white d-flex align-items-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap overflow-auto">
                            <h1 className="title-semibold fs-24 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                                View/Edit Produce Credit
                            </h1>
                        </div>
                        <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 flex-nowrap">
                            <div className="custom-group flex-nowrap">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Code:
                                </label>
                                <div className="date position-relative cme-15">
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        placeholder="Code"
                                        defaultValue={customerDetailsObj?.CustomerCode}
                                        style={{ width: "100px" }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="custom-group flex-nowrap">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Customer:
                                </label>
                                <div className="date position-relative cme-15">
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        placeholder="Customer"
                                        defaultValue={customerDetailsObj?.CustomerName}
                                        style={{ width: "360px" }}
                                        disabled
                                    />
                                </div>
                            </div>

                            <div className="custom-group flex-nowrap mb-lg-0">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Return date:
                                </label>
                                <div className="position-relative cme-12" data-provide="datepicker">
                                    <input
                                        type="date"
                                        id="datepicker"
                                        className="form-control input-sm date input-datepicker"
                                        placeholder="Select Date"
                                        value={returnDate}
                                        onChange={(e) => {
                                            setReturnDate(e.target.value);
                                        }}
                                    />
                                </div>

                            </div>
                            <div className="custom-group flex-nowrap mb-lg-0 pe-3">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Credit No:
                                </label>
                                <input
                                    type="text"
                                    className={`form-control input-sm input-width-100`}
                                    defaultValue={id}
                                    disabled
                                />
                            </div>

                            <div className="custom-group flex-nowrap">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Reference:
                                </label>
                                <div className="date position-relative cme-15">
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        value={reference}
                                        style={{ width: "100px" }}
                                        onChange={(e) => setReference(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-4 border-bottom">
                            <div className="card-table table-responsive">
                                <table className="table table-form disable-field">

                                    <thead>
                                        <tr>
                                            <td scope="col" className="width-lg-1"></td>
                                            <td scope="col" className="width-lg-4">
                                                Qty
                                            </td>
                                            <td scope="col" className="width-lg-4">
                                                Unit
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Produce
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Agent
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Comment
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Produce Credit
                                            </td>
                                            <td scope="col" className="width-lg-1"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {creditDetails.length > 0 && creditDetails.map((creditDetailItem, index) => {
                                            return (<tr key={index + 1} className="custom-space">
                                                <td valign="middle">
                                                    <img src={triangle} className="indicator" alt="" />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control input-sm text-end input-width-90"
                                                        placeholder="Qty"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevProdDetails => {
                                                                const updatedProdDetails = [...prevProdDetails];
                                                                updatedProdDetails[index].Qty = e.target.value;
                                                                return updatedProdDetails;
                                                            });
                                                        }}
                                                        value={creditDetailItem.Qty}
                                                    />
                                                </td>
                                                <td>
                                                    <Select
                                                        className="input-sm input-width-90"
                                                        value={units.find(unit => unit.value == creditDetailItem.UnitID) || ''}
                                                        options={units}
                                                        placeholder="Select Unit"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevProdDetails => {
                                                                const updatedProdDetails = [...prevProdDetails];
                                                                updatedProdDetails[index].UnitID = e.value;
                                                                return updatedProdDetails;
                                                            });
                                                        }}
                                                        components={{ Option: CustomOption }}
                                                    ></Select>
                                                </td>
                                                <td>
                                                    <Select
                                                        className="input-sm input-width-90"
                                                        value={products.find(product => product.value == creditDetailItem.ProductID) || ''}
                                                        options={products}
                                                        placeholder="Select Product"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevProdDetails => {
                                                                const updatedProdDetails = [...prevProdDetails];
                                                                updatedProdDetails[index].ProductID = e.value;
                                                                return updatedProdDetails;
                                                            });
                                                        }}
                                                        components={{ Option: CustomOption }}
                                                    ></Select>
                                                </td>
                                                <td>
                                                    <Select
                                                        className="input-sm input-width-90"
                                                        value={agents.find(agent => agent.value == creditDetailItem.AgentID) || ''}
                                                        options={agents}
                                                        placeholder="Select Agent"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevProdDetails => {
                                                                const updatedProdDetails = [...prevProdDetails];
                                                                updatedProdDetails[index].AgentID = e.value;
                                                                return updatedProdDetails;
                                                            });
                                                        }}
                                                        components={{ Option: CustomOption }}
                                                    ></Select>
                                                </td>
                                                <td>
                                                    <div>
                                                        <input
                                                            type="text"
                                                            className="form-control input-sm text-end ps-4 input-width-110"
                                                            value={creditDetailItem.Comment}
                                                            onChange={(e) => {
                                                                setCreditDetails(prevProdDetails => {
                                                                    const updatedProdDetails = [...prevProdDetails];
                                                                    updatedProdDetails[index].Comment = e.target.value;
                                                                    return updatedProdDetails;
                                                                });
                                                            }}

                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="position-relative input-icon">
                                                        <input
                                                            type="text"
                                                            className="form-control input-sm text-end ps-4 input-width-110"
                                                            value={creditDetailItem.ProdCreditAmt}
                                                            onChange={(e) => {
                                                                setCreditDetails(prevProdDetails => {
                                                                    const updatedProdDetails = [...prevProdDetails];
                                                                    updatedProdDetails[index].ProdCreditAmt = formatPrice(e.target.value);
                                                                    return updatedProdDetails;
                                                                });
                                                            }}
                                                            onBlur={(e) => {
                                                                setCreditDetails(prevProdDetails => {
                                                                    const updatedProdDetails = [...prevProdDetails];
                                                                    updatedProdDetails[index].ProdCreditAmt = addTrailingZeros(e.target.value);
                                                                    return updatedProdDetails;
                                                                });
                                                                addNewRow(e, index)
                                                                calculateGST(addTrailingZeros(e.target.value), index);
                                                            }}
                                                        />
                                                        <span className="text-lite cps-10 fs-14">$</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-inline-flex align-items-center justify-content-end flex-grow-1">
                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleRowDelete(index)}
                                                            className={`text-decoration-none ${creditDetails.length - 1 === index ? 'd-none' : ''} `}
                                                        >
                                                            <i className="icon icon-delete ms-3 text-danger fw-bold"></i>
                                                        </div>
                                                    </div>
                                                </td>

                                            </tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {!message && <div className="text-center"><span className='text-danger'>Kindly Save the Data before Exit Otherwise Data will be lost</span></div>}
                            <div className="row d-flex justify-content-between align-items-end mt-2 mt-lg-0 pb-3">
                                <div className="col-md-2 d-flex">
                                    <label className="p-1">
                                        Items:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control input-sm text-end ps-4"
                                        //  value={creditDetails.length - 1}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2 d-flex">
                                    <label className="p-1">
                                        Total:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control input-sm text-end ps-4"
                                        value={calculateTotalCredit()}
                                        readOnly
                                    />
                                </div>
                            </div>

                            <div className="col d-flex justify-content-between align-items-end mt-4 mt-lg-0">
                                <div className="d-flex">
                                    <button type="button"
                                        role="button"
                                        className="btn btn-md btn-outline-danger d-flex align-items-center px-4 fw-medium rounded-3 mx-1 text-nowrap"
                                        onClick={() => setShowDeleteCreditModal(true)}
                                    >
                                        Delete Credit Note
                                    </button>
                                </div>
                                <div className="d-flex">
                                    <button
                                        onClick={handlePreview}
                                        type="button"
                                        className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    >
                                        Preview
                                    </button>
                                    <button type="button"
                                        onClick={handleUpdate}
                                        //disabled={creditDetails.length === 1}
                                        className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    >
                                        Update Credit Note
                                    </button>
                                    <button type="button"
                                        onClick={() => { navigate("/all-produce-credits") }}
                                        className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                                    >
                                        Exit
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>
            </main>
        </React.Fragment>
    )
}

export default ViewEditProduceCredit
